import { render, staticRenderFns } from "./AdministrationRolesContentMenu.vue?vue&type=template&id=312da802&scoped=true"
import script from "./AdministrationRolesContentMenu.vue?vue&type=script&lang=ts"
export * from "./AdministrationRolesContentMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312da802",
  null
  
)

export default component.exports